/**
 * @Description: 详情页使用详情和修订记录部分功能
 * @author zhaijiayu
 * @date 2021/8/23
*/
<template>
  <div class="material-container-extra">
    <el-tabs v-model="activeTab" >
      <el-tab-pane label="使用稿件" name="usage">
        <el-table :data="manuscript" width="100%">
          <el-table-column
              prop="nm_title"
              label="标题"
              class-name="long-text"
          >
          </el-table-column>
          <el-table-column
              label="类型"
              width="100"

          >
            <template slot-scope="{ row }">
              {{ row.nm_type | getArticleTypeName }}
            </template>
          </el-table-column>
          <el-table-column
              prop="phone"
              label="作者"
              width="200"
              class-name="long-text"
          >
          </el-table-column>
          <el-table-column
              prop="nm_create_time"
              label="操作时间"
              width="200"
          >
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="操作记录" name="record" class="record">
        <div class="record-item"
             v-for="item in logs"
             :key="item.cml_create_time"
        >
          <p class="date">{{ item.cml_create_time }}</p>
          <div  class="record-info">
            <span class="text" v-if="item.phone">操作人：{{ item.phone || '-' }}</span>
            <span class="record-operation">{{ item.cml_behavior | getBehaviorName }}</span>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { MANUSCRIPT_TYPE } from "../../../constants/manuscript";

export default {
  name: 'materialDetailExtra',
  props: {
    logs: Array,
    manuscript: Array
  },
  filters: {
    getBehaviorName: function (behavior){
      const behaviorMap = {
        1 : '上传',
        2 : '使用',
        3 : '下载',
        4 : '保存',
        7 : 'AI审核失败',
        8 : 'AI审核通过',
        9 : '删除',
        5 : '分享',
      }
      return behaviorMap[behavior]
    },
    getArticleTypeName: function (type){
      return MANUSCRIPT_TYPE[type]
    }
  },
  data: function (){
    return {
      activeTab: 'usage',
    }
  }
}
</script>
<style lang="scss" scoped>
.material-container-extra{
  margin: 20px;

  /deep/.long-text .cell{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .record{
    background: #fff;
    padding: 20px 20px 0 20px;

    .record-item{
      padding-bottom: 10px;
    }
    .record-info{
      color: #606266;
      padding: 4px 0;
      display: flex;
      margin: 5px 0;

      .record-operation{
        margin-left: 20px;
        color: #303133;
      }
    }
  }
}
</style>